import { getAuthCookie } from '@/lib/utils/shared/cookies/getAuthCookie'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'
import { useSignOutUser } from './useSignOutUser'

// This hook should refresh the login state of the user, but it seems we don't support that feature yet.
// For now, it will check if the auth cookie is missing, if it is, we will sign out the user.

export const useRefreshLoginState = () => {
  const {
    user: { customer },
  } = useGlobalStore()
  const { signOutUser } = useSignOutUser()

  useEffect(() => {
    ;(async () => {
      const authCookie = getAuthCookie()

      if (authCookie) {
        // make refresh token call here
        // if customer.href, customer data exists,
        // clear all customer data if no login token
      } else if (customer) {
        // if auth cookie is expired auto-sign out user
        await signOutUser()
      }
    })().catch(() => {})
  }, [customer, signOutUser])
}
